import { useEffect } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setViewWidth } from '../../modules/view';
import MyBoxPage from '../MyBoxPage/MyBoxPage';
import './App.css';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import { GlobalFooter } from '@fff-web/fff-global-footer';
import { GlobalNav } from '@fff-web/fff-global-nav';
import { useUserContext } from '@fff-web/fff-utilities';
import env from '../../utils/env';
import optimizelyClientInstance from '../../utils/optimizely/client';
import { getUUID } from '../../utils/optimizely/getUUID';

const App = ({ setViewWidthAction }) => {
  const { userInfo } = useUserContext();
  const optimizelyUserId = String(userInfo?.user?.userId ?? getUUID());

  useEffect(
    () => window.addEventListener('resize', () => setViewWidthAction(window.innerWidth)),
    [setViewWidthAction],
  );

  return (
    <OptimizelyProvider optimizely={optimizelyClientInstance} user={{ id: optimizelyUserId }}>
      <div>
        <GlobalNav />
        <main className="my-box-page">
          <Routes>
            <Route path="*" element={<MyBoxPage />} />
          </Routes>
        </main>
        <GlobalFooter
          chatbotConfig={{ agentId: env.appliedLabsChatbotAgentId, hideWidget: false }}
        />
      </div>
    </OptimizelyProvider>
  );
};

const mS = (state) => ({
  isMobile: state.view.isMobile,
});

const mD = (dispatch) =>
  bindActionCreators(
    {
      setViewWidthAction: setViewWidth,
    },
    dispatch,
  );

App.propTypes = {
  setViewWidthAction: func.isRequired,
};

export default connect(mS, mD)(App);
